'use client';

import { useEffect } from 'react';
import { APP_VERSION } from '@/config/app';

export default function VersionCheck() {
    useEffect(() => {
        // Run on mount
        const storedVersion = localStorage.getItem('app_version');

        if (storedVersion && storedVersion !== APP_VERSION) {
            console.log(`[VersionCheck] New version detected: ${APP_VERSION} (current: ${storedVersion})`);
            console.log(`[VersionCheck] Performing automatic cache clear and reload...`);

            // Clear storage to ensure no stale data remains
            localStorage.clear();
            sessionStorage.clear();

            // Set the new version so this won't repeat after reload
            localStorage.setItem('app_version', APP_VERSION);

            // Force reload from server (silent - no modal)
            window.location.reload();
        } else if (!storedVersion) {
            // First visit, just set the version
            localStorage.setItem('app_version', APP_VERSION);
        }
    }, []);

    // No UI - silent operation
    return null;
}
